module.exports = __webpack_public_path__ + "home-icon-on.png?91e4384fcd84d5dbd41a09aec92b0ea8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-icon-on.png
// module id = 47
// module chunks = 0